import { titleCase } from "../../../helper";
import {
  BoxTab,
  BoxTabEach,
  TabHeader,
  TabSub,
} from "../../../pages/YachtClubViewDetails";
import ImageClickModal from "../../ImageClickModal";

interface VesselDocumentProps {
  idCard: string;
  vesselPicture: string;
  vesselRegistration: string;
  vesselInsurance: string;
  idSrc: string;
  vesselPictureSrc: string;
  vesselRegistrationSrc: string;
  vesselInsuranceSrc: string;
}

const VesselDocument = ({
  idCard,
  vesselPicture,
  vesselRegistration,
  vesselInsurance,
  idSrc,
  vesselPictureSrc,
  vesselRegistrationSrc,
  vesselInsuranceSrc,
}: VesselDocumentProps) => {
  return (
    <BoxTab>
      <BoxTabEach>
        <TabHeader>ID Card</TabHeader>
        <TabSub>{titleCase(idCard)}</TabSub>
        <ImageClickModal imgSrc={idSrc} width="192px" height="108px" />
      </BoxTabEach>
      <BoxTabEach>
        <TabHeader>Vessel Picture</TabHeader>
        <TabSub>{titleCase(vesselPicture)}</TabSub>
        <ImageClickModal
          imgSrc={vesselPictureSrc}
          width="192px"
          height="108px"
        />
      </BoxTabEach>
      <BoxTabEach>
        <TabHeader>Vessel Registration</TabHeader>
        <TabSub>{titleCase(vesselRegistration)}</TabSub>
        <ImageClickModal
          imgSrc={vesselRegistrationSrc}
          width="192px"
          height="108px"
        />
      </BoxTabEach>
      <BoxTabEach>
        <TabHeader>Vessel Insurance</TabHeader>
        <TabSub>{titleCase(vesselInsurance)}</TabSub>
        <ImageClickModal
          imgSrc={vesselInsuranceSrc}
          width="192px"
          height="108px"
        />
      </BoxTabEach>
    </BoxTab>
  );
};

export default VesselDocument;
